import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var IconHeat16pxBold = function IconHeat16pxBold(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color
  }, otherProps), {}, {
    viewBox: "0 0 16 16",
    children: /*#__PURE__*/_jsx("path", {
      d: "M6.584 15S.533 13.634 3.238 6.856c0 0 .614.753.53 1.116 0 0 .48-1.711 1.52-2.733C6.18 4.361 7.086 1.892 6.25 1c0 0 4.14.892 4.602 5.355 0 0 .53-1.422 1.617-1.563 0 0-.335.781 0 1.953 0 0 3.43 6.024-2.481 8.06 0 0 1.771-2.064-1.986-5.607 0 0-.886 1.897-1.416 2.566-.002.002-1.48 1.702-.002 3.236z"
    })
  }));
};
export default IconHeat16pxBold;